import { api } from "./api";

export const GET_ALL_MODELS = async () => {
    const { data } = await api.get("/models")
    return data.models || [];
}

export const GET_MODEL = async (id: string) => {
    const { data } = await api.get(`/models/${id}`)
    return data;
}

export const DELETE_MODEL = async (id: string) => {
    const { data } = await api.delete(`/models/${id}`)
    return data;
}

export const CREATE_MODEL = async (params: any) => {
    const { data } = await api.post(`/models`, params)
    return data;
}

export const UPDATE_MODEL = async (id: string, params: any) => {
    const { data } = await api.patch(`/models/${id}`, params)
    return data;
}

